import { createStore, applyMiddleware, compose } from 'redux'
import thunkMiddleware from 'redux-thunk'
import reducer from './reducers'
import { composeWithDevTools } from 'redux-devtools-extension/logOnlyInProduction'

export default (initialState = {}) => {
  const middlewares = [thunkMiddleware]
  if (process.env.NODE_ENV === 'development') {
    const { createLogger } = require('redux-logger')
    const logger = createLogger({
      predicate: (getState, action) => true
    })
    middlewares.push(logger)
  }

  const composeEnhancers = composeWithDevTools({
    // options like actionSanitizer, stateSanitizer
  })

  const store = createStore(reducer, initialState, composeEnhancers(
    applyMiddleware(...middlewares),
  ))

  if (process.env.NODE_ENV !== "production") {
    if (module.hot) {
      module.hot.accept('./reducers', () => {
        store.replaceReducer(reducer)
      })
    }
  }

  return store
}
